import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/usuarioContribuinte/';

class UsuarioContribuinteService {
    constructor() {
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type':'application/json',
                'authorization':'Bearer ' + (data ? data.token:'')
            };
        });
    }

    findAllByUsuario(idCliente, idUsuario) {
        return axios.get(API_URL + 'filter?idCliente='+idCliente+'&idUsuario='+idUsuario, {headers: this.headers});
    }

    findContribuinteByDocumento(idCliente, documento) {
        return axios.get(API_URL + 'filterContribuinteByDoc?idCliente='+idCliente+'&documento='+documento, {headers: this.headers});
    }

    transferirInscricao(idCliente, novoIdContribuinte, idContribuinte) {
        return axios.get(API_URL + 'transferirInscricao?idCliente='+idCliente+'&novoIdContribuinte='+novoIdContribuinte+'&idContribuinte='+idContribuinte, {headers: this.headers});
    }    
    
    findAllByContribuinte(idCliente, idContribuinte) {
        return axios.get(API_URL + 'filterContribuinte?idCliente='+idCliente+'&idContribuinte='+idContribuinte, {headers: this.headers});
    }

    findAllByConttribuinteFiltro(idCliente, idConta, filtro) {
        return axios.get(API_URL + 'filterContr?idCliente='+idCliente+'&idConta='+idConta+'&filtro='+filtro, {headers: this.headers}).then(response => (this.data = response.data.elements));
    }

    save(idUsuario, idContribuinte) {
        return axios.post(API_URL+'save?idUsuario='+idUsuario+'&idContribuinte='+idContribuinte, null,
        {headers: this.headers});
    }

    
    remove(id) {
        return axios.post(API_URL+'remove?id='+id, null,
        {headers: this.headers});
    }

    cript(chave) {
        return axios.post(API_URL+'cript?chave='+chave, null,
        {headers: this.headers});
    }
    
}

export default new UsuarioContribuinteService();